module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Day":"Day","Month":"Month","Ordinarily":"Ordinarily","DayRepeatMonthly":"Day repeat monthly","TimeRepeatMonthly":"Time repeat monthly"},"vi":{"Day":"Ngày","Month":"Tháng","Ordinarily":"Thứ tự","DayRepeatMonthly":"Vào ngày","TimeRepeatMonthly":"Vào thời điểm"}}')
  delete Component.options._Ctor
}
